import React, { Dispatch, useState } from 'react'
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { IJob } from '../../../../interfaces/Job';
import ApiCalls from '../../../../network/ApiCalls';
import { JobAction } from '../../../../redux/actionTypes/jobTypes';
import * as jobActionCreator from '../../../../redux/actionCreators/jobActionCreators';
import { RedusxAppState } from '../../../../redux/reducers/rootReducer';
import DeleteDialog from '../../../../umut-components/Modals/DeleteDialog';
import TaskTable from './TaskTable';
import TaskDialog from './TaskDialog';
import SkeletonTableLoading from '../../../../umut-components/Loading/SkeletonTableLoading';
import { decryptText } from '../../../../utils/util';
import { JobStatusObj } from '../../../../enums/JobEnum';

type Props = {
    jobEventsActive: boolean
}

const TasksTab: React.FC<Props> = ({ jobEventsActive }) => {
    const dispatch = useDispatch<Dispatch<JobAction>>();
    let { jobId }: any = useParams();
    jobId = decryptText(jobId);
    const { jobDetail } = useSelector((state: RedusxAppState) => state.job);
    const { data, isLoading, error, refetch } = useQuery(['Get Job Tasks By Job Id', jobId], () => ApiCalls.getJobTasks(jobId), { cacheTime: 500000, refetchOnWindowFocus: false, enabled: jobId ? true : false });

    if (isLoading) {
        return <SkeletonTableLoading />
    }

    if (error) {
        return <div className='d-flex justify-content-center p-6'>Error</div>
    }

    return (
        <>
            <TaskTable data={data?.data?.data} refetch={refetch} jobEventsActive={jobEventsActive} />
            {
                jobEventsActive &&
                <>
                    <div className='d-flex justify-content-end mt-6'>
                        <button type='button' className='btn btn-success' onClick={() => { dispatch(jobActionCreator.openTaskDialog(refetch)) }}>Add Task</button>
                    </div>
                    <TaskDialog />
                </>
            }
            <DeleteDialog />
        </>
    )
}

export default TasksTab;